import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import AgencySelect from '../../form/components/specialized/AgencySelect';
import EmployeeSelect from '../../form/components/specialized/EmployeeSelect';
import { useFieldFast } from '../../form/hooks';
import { selectAgencyById } from '../../agencies/agenciesSlice';

const AgencyEmployeeSelect = ({
    name,
    agencyFieldName,
    label,
    agencyLabel,
    fullWidth,
    disabled,
    agencyReadOnly,
}) => {
    const [{ value: agencyId }, { initialValue: initialAgencyId }] = useField(agencyFieldName);
    const [, { initialValue: initialEmployeeId }, { setValue: setEmployeeId }] = useFieldFast(name);
    const agency = useSelector((state) => selectAgencyById(state, agencyId));

    const handleAgency = useCallback(
        (field, value) => {
            setEmployeeId(value === initialAgencyId ? initialEmployeeId : '');
        },
        [setEmployeeId, initialAgencyId, initialEmployeeId]
    );

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                {agencyReadOnly ? (
                    // the agency of an existing contract (or of an addendum, which inherits
                    // it from its parent) is fixed - see docs/plans/care-need-single-agency.md
                    <TextField
                        label={agencyLabel}
                        value={agency ? agency.matchCode || agency.name : ''}
                        fullWidth={fullWidth}
                        disabled
                    />
                ) : (
                    <AgencySelect
                        name={agencyFieldName}
                        label={agencyLabel}
                        onChange={handleAgency}
                        fullWidth={fullWidth}
                        disabled={disabled}
                    />
                )}
            </Grid>
            <Grid item xs={6}>
                <EmployeeSelect
                    name={name}
                    label={label}
                    agencyId={agencyId}
                    fullWidth={fullWidth}
                    disabled={disabled || !agencyId}
                />
            </Grid>
        </Grid>
    );
};

AgencyEmployeeSelect.propTypes = {
    name: PropTypes.string.isRequired,
    agencyFieldName: PropTypes.string.isRequired,
    label: PropTypes.string,
    agencyLabel: PropTypes.string,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    agencyReadOnly: PropTypes.bool,
};

AgencyEmployeeSelect.defaultProps = {
    label: null,
    agencyLabel: null,
    fullWidth: false,
    disabled: false,
    agencyReadOnly: false,
};

export default AgencyEmployeeSelect;
